/* ═══════════════════════════════════════════════════════════════════════════
   Theme — shared visual design tokens and inline-style helpers for the app.
   Pure values and style factories only: no JSX, no component logic, no state.
   Extracted from App.jsx (2026-05-29); see
   docs/superpowers/specs/2026-05-29-app-jsx-decomposition-design.md
   ═══════════════════════════════════════════════════════════════════════════ */

/* ═══ BRAND COLORS ═══ */
export const CL = {
  sand: "#F5EFE6", cream: "#FFFDF8", bark: "#3D2B1F",
  gold: "#C9A96E", goldL: "#E8D5B0", olive: "#5A7247",
  sea: "#2B6F8A", terra: "#C0562B", stone: "#8B7D6B",
  apt: "#FBF6EC",
};

/* ═══ TYPOGRAPHY ═══ */
export const FONT = {
  display: "'Cormorant Garamond', Georgia, serif",
  body: "'Figtree', 'Helvetica Neue', -apple-system, sans-serif",
};

export const HAIRLINE = "#F0EBE1";

/* ═══ STYLE OBJECTS ═══ */
export const st = {
  hdr: { background: CL.bark, color: CL.cream, padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 50 },
  hBtn: { background: "none", border: "none", color: CL.cream, cursor: "pointer", padding: "4px 8px", fontSize: 18 },
  card: { background: CL.cream, borderRadius: 14, padding: "14px 16px", margin: "10px 14px", boxShadow: "0 1px 4px rgba(61,43,31,0.08)" },
  inp: { width: "100%", padding: "11px 14px", border: "1.5px solid " + CL.goldL, borderRadius: 10, fontSize: 16, fontFamily: "inherit", background: "#FFFEF9", outline: "none", boxSizing: "border-box", color: "#3D2B1F", colorScheme: "light" },
  lbl: { fontSize: 11, fontWeight: 700, color: CL.stone, letterSpacing: 1, textTransform: "uppercase", marginBottom: 6, display: "block" },
  sec: { fontSize: 12, fontWeight: 700, color: CL.stone, letterSpacing: 1.2, textTransform: "uppercase", padding: "14px 18px 6px" },
  btnP: { background: CL.olive, color: "#fff", border: "none", borderRadius: 12, padding: "14px 24px", fontSize: 16, fontWeight: 600, cursor: "pointer", width: "100%", letterSpacing: 0.3 },
  step: { background: CL.goldL, border: "none", borderRadius: 8, width: 36, height: 36, fontSize: 18, fontWeight: 700, cursor: "pointer", color: CL.bark, display: "flex", alignItems: "center", justifyContent: "center" },
  toast: { position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", background: CL.bark, color: CL.gold, padding: "10px 22px", borderRadius: 10, fontSize: 14, fontWeight: 600, zIndex: 999, boxShadow: "0 4px 20px rgba(0,0,0,0.25)" },
  nav: { position: "fixed", bottom: 0, left: 0, right: 0, background: CL.bark, display: "flex", justifyContent: "space-around", alignItems: "flex-end", padding: "6px 0 env(safe-area-inset-bottom, 6px)", zIndex: 50 },
};

// Locked redesign panel: cream surface, goldL hairline border, 12px radius.
export const panelStyle = { background: CL.cream, padding: '14px 16px', borderRadius: 12, border: `1px solid ${CL.goldL}`, marginBottom: 10 };

export function badge(c) { return { display: "inline-block", background: c, color: "#fff", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 600 }; }
export function payCol(s) { return s === "Paid" ? CL.olive : s === "Deposit" ? "#B8860B" : CL.terra; }
